import React from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'
import "./homeicu_css.css";
import "./homeicu_js.js";
import ServiceShowcase from "../ServiceShowCase.jsx";
import CardSlider from '../CardSlider.jsx';
import banner from "../../Assets/cover.png";
import ServicesGrid from "../ServiceGrid.jsx";
import CardsContainer from "../CardsContainer.jsx";
import Testimonials from "../../Testimonial/Testimonial.jsx";
import CoverHero from "../CoverHero.jsx";
import { useState } from "react";
import Slider from 'react-slick';
import LoginModal from "../../Modals/LoginModal.js";
import {
    serviceShowcaseData, heading1, paragraph1,
    cardsheading, homeicuservices, suportyourjourney, criticalneed_data,
    homeicu_testimonials,
    sliderdata, settings3
} from './homeicu_js.js';
import { useNavigate } from 'react-router-dom';

const HomeIcu = () => {
    const navigate = useNavigate();

    return (
        <>
            <Header />
            <CoverHero image={banner} title="Home ICU Setup" />
            <div className="servicesShowCase">
                {serviceShowcaseData.map((service, index) => (
                    <ServiceShowcase
                        key={index}
                        className="medical-equ icu-services"
                        data={service}
                        onServiceClick={() => navigate('/')}

                    />
                ))}
                <div className="texts-radiology">
                    <h2>{heading1}</h2>
                    <p>{paragraph1}</p>
                </div>
            </div>

            <CardsContainer
                heading={cardsheading}
                services={Object.values(homeicuservices)}
            />

            <CardSlider
                className="home-icu-slider"
                heading="Support Your Journey To Recovery"
                heading2={<span style={{ color: '#656B70', fontSize: "18px" }}>ICU Setup serves the purpose of providing care to patients who are</span>}
                data={suportyourjourney}
            />
            <div className="choose-excellence">
                <h2 className="excellence-title">{criticalneed_data.title}</h2>
                <div className="excellence-content">
                    <div className="icu-image-container">
                        <p>{criticalneed_data.para1}</p>
                        <p>{criticalneed_data.para2}</p>
                        <p>{criticalneed_data.para3}</p>
                    </div>

                    <div className="image-container">
                        <img src={criticalneed_data.image} alt={criticalneed_data.title} />
                    </div>
                </div>
            </div>
            <div className="excellence-testimonials-container">
                <Testimonials
                    data={homeicu_testimonials}
                    textKey="desc"
                    imgKey="userimg"
                    nameKey="username"
                    className="excellence-testimonials"
                />
            </div>
            <div className="endorsed grey-bg">
                <h2>Backed</h2>
                <Slider {...settings3}>
                    {sliderdata.map((item, index) => (
                        <div key={index} className="endorse-card">
                            <img src={item.logo} alt={item.name} />
                        </div>
                    ))}
                </Slider>
            </div>
            <ServicesGrid className="bg-white" title="Check Our Other Services" exclude="Home ICU Setup" />

            <Footer />
        </>
    )
}

export default HomeIcu
